"use client";
import Image from "next/image";

export default function WorkingProcess() {
  return (
    <section className="bg-[#003953] py-10 md:py-16">
      <div className="max-w-7xl mx-auto px-4">

        <div className="grid md:grid-cols-2 gap-10 items-center">

          {/* LEFT CONTENT */}
          <div className="text-white space-y-5">
            <h2 className="text-3xl md:text-4xl font-bold">
              Join Our Team
            </h2>

            <p className="text-sm md:text-base leading-relaxed">
              Be part of Medhavi Skills University and contribute to an
              innovative academic environment focused on skill-based learning.
            </p>

            <div className="bg-white text-black p-4 rounded-lg shadow-md">
              <h3 className="font-semibold text-lg mb-2">
                Academic Positions
              </h3>

              <ul className="text-sm space-y-2">
                <li>• Associate Dean & Associate Professor</li>
                <li>• Principal & Professor (Nursing)</li>
              </ul>
            </div>

            <a
            href="mailto:careers@msu.edu.in?subject=Application for Academic Position&body=Dear MSU Team,"
            className="inline-block bg-[#f4a62a] text-white px-6 py-3 font-medium hover:opacity-90 transition"
            >
            Apply Now
            </a>
          </div>

          {/* RIGHT IMAGE (FULL PORTRAIT) */}
          <div className="bg-white p-3 shadow-xl border-4 border-white">
            <Image
              // src="https://cdn.msu.edu.in/msu-reavamp/images/hiring_academic_employee.jpeg"
              src="https://cdn.msu.edu.in/msu-reavamp/images/hiring-professors.jpg"
              alt="Hiring Banner"
              width={800}
              height={1200}
              className="w-full h-auto object-contain"
            />
          </div>

        </div>
      </div>
    </section>
  );
}